import React, { useMemo } from 'react';

import { NotificationsResponse } from 'services/mainNotificationsServices';
import { useNotificationContext } from 'hooks/useNotifications';
import { useMediaQuery } from 'react-responsive';
import {
  Container,
  Title,
  Separator,
  Content,
  Status,
  Description,
  Details,
  ItemWrap,
  LabelItem,
  ValueItem,
} from './styles';
import { getStatusType } from './util';

type NotificationDetailsData = {
  caseNumber: string;
  reason: string;
  subject: string;
  caseId?: string;
  status: string;
  recordType: string;
  currentGasPercentage: string | number;
};

type Props = {
  data: NotificationsResponse;
  lastData: boolean;
};

const NotificationItem: React.FC<Props> = ({ data, lastData }) => {
  const { handleNotificationIsRead } = useNotificationContext();
  const notificationDetails: NotificationDetailsData = JSON.parse(data.body);

  const isMobile = useMediaQuery({ maxWidth: 600 });

  const handleClickNotification = async (
    caseId: string,
    currentGasPercentage: string | number
  ): Promise<void> => {
    await handleNotificationIsRead(data.id);
    if (currentGasPercentage) {
      window.location.href = `/tracking?caseId=${caseId}`;
    } else {
      window.location.href = `/manutencao?caseId=${caseId}`;
    }
  };

  const statusDescription = useMemo(() => {
    const type =
      notificationDetails.recordType === 'ManutencaoCorretiva'
        ? 'assistancie'
        : 'refuel';
    return getStatusType(notificationDetails.status, type);
  }, [notificationDetails]);

  return (
    <Container
      onClick={() => {
        if (notificationDetails?.caseId)
          handleClickNotification(
            notificationDetails.caseId,
            notificationDetails.currentGasPercentage
          );
      }}
    >
      <Content status={notificationDetails.status}>
        {!isMobile && <Status status={notificationDetails.status} />}
        <Description>
          <Title>{data.title}</Title>
          {!isMobile && (
            <>
              <Details>
                <ItemWrap>
                  <LabelItem>Status:</LabelItem>
                  <ValueItem>{statusDescription || ''}</ValueItem>
                </ItemWrap>
                <ItemWrap>
                  <LabelItem>Protocolo:</LabelItem>
                  <ValueItem>{notificationDetails.caseNumber}</ValueItem>
                </ItemWrap>
              </Details>
              <Details>
                <ItemWrap>
                  <LabelItem>Tipo:</LabelItem>
                  <ValueItem>{notificationDetails.subject}</ValueItem>
                </ItemWrap>
                <ItemWrap>
                  <LabelItem>Motivo:</LabelItem>
                  <ValueItem>{notificationDetails.reason}</ValueItem>
                </ItemWrap>
              </Details>
            </>
          )}
          {isMobile && (
            <>
              <Details>
                <ItemWrap>
                  <LabelItem>Status:</LabelItem>
                  <ValueItem>{statusDescription || ''}</ValueItem>
                  <Status status={notificationDetails.status} />
                </ItemWrap>
              </Details>
              <Details>
                <ItemWrap>
                  <LabelItem>Protocolo:</LabelItem>
                  <ValueItem>{notificationDetails.caseNumber}</ValueItem>
                </ItemWrap>
              </Details>
              <Details>
                <ItemWrap>
                  <LabelItem>Tipo:</LabelItem>
                  <ValueItem>{notificationDetails.subject}</ValueItem>
                </ItemWrap>
              </Details>
              <Details>
                <ItemWrap>
                  <LabelItem>Motivo:</LabelItem>
                  <ValueItem>{notificationDetails.reason}</ValueItem>
                </ItemWrap>
              </Details>
            </>
          )}
        </Description>
      </Content>
      {!lastData && <Separator />}
    </Container>
  );
};

export default NotificationItem;
